module.exports = __webpack_public_path__ + "static/media/OGG-web-terms.5bdb527c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-web-terms.jpg
// module id = 636
// module chunks = 0